import { render, staticRenderFns } from "./testGold.vue?vue&type=template&id=755016de&scoped=true"
import script from "./testGold.vue?vue&type=script&lang=js"
export * from "./testGold.vue?vue&type=script&lang=js"
import style0 from "./testGold.vue?vue&type=style&index=0&id=755016de&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "755016de",
  null
  
)

export default component.exports